<template>
  <div class="vld-parent" ref="investor_evaluations">
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você confere todos os processos de due diligences em aberto
              para os fundos de investimentos nos quais você participa. Você
              pode ver com detalhes as startups participantes no processo de
              diligência prévia.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div v-if="!empty" class="card-deck">
            <div
              class="col-lg-4 col-md-6 d-flex align-items-stretch"
              v-for="dueDiligence in dueDiligences"
              :key="'due_diligence_' + dueDiligence.id"
            >
              <div class="card card-profile shadow flex-grow-1">
                <div class="row justify-content-center">
                  <div class="col-lg-3 order-lg-2">
                    <div class="card-profile-image">
                      <img
                        src="/img/pages/evaluation.png"
                        class="rounded-circle"
                      />
                    </div>
                  </div>
                </div>
                <div class="card-body pt-0 mt-7">
                  <div class="text-center mt-5">
                    <h3 class="mt-3">
                      Due Diligence
                      <span class="text-warning">STARS</span>
                    </h3>
                    <div class="col-12 text-center mt-3">
                      <span class="bg-white border rounded py-2 px-3"
                        >{{ dueDiligence.countSubscriptions }}
                        <i class="ni ni-spaceship ml-1 text-danger"></i
                      ></span>
                    </div>
                    <div class="row mt-md-3 mb-2">
                      <div class="col text-center text-muted">
                        Processo de diligência prévia para
                        <span class="text-warning"
                          >{{ dueDiligence.callType }} STARS</span
                        >, pertencente à chamada
                        <span class="font-weight-bold text-dark">{{
                          dueDiligence.callName
                        }}</span
                        >.
                      </div>
                    </div>
                    <h3>
                      Início:
                      <span class="font-weight-light">
                        {{ formatDate(dueDiligence.date, "L") || "..." }}
                      </span>
                    </h3>
                    <hr class="my-3" />
                    <base-button
                      type="primary"
                      :custom="true"
                      class="mt-2"
                      @click="handleViewDueDiligence(dueDiligence.id)"
                      >Visualizar Startups</base-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="row">
            <div class="col-12 text-center">
              <badge type="info" class="bg-white">
                Nenhum processo de due diligence vinculado aos seus fundos de
                investimentos está disponível para visualização no momento.
              </badge>
            </div>
          </div>
          <!-- <hr class="mt-7 mb-1" />
          <div class="col text-right mt-3">
            <base-button type="link" :custom="true"
              >Ver histórico de due diligences</base-button
            >
          </div> -->
        </div>
      </div>
    </div>
    <modal
      :show.sync="showModal"
      :closeOnClick="false"
      modal-classes="modal-warning modal-dialog-centered modal-default"
    >
      <h6 class="modal-title mb-4" id="modal-title-notification">Atenção!</h6>
      <div class="text-center">
        <i class="fa fa-exclamation-circle fa-3x"></i>
        <h4 class="heading mt-4">
          Prezado
          <span class="text-warning text-default-case">investidor</span>,
        </h4>
        <p class="my-4">
          Não há nenhum processo de
          <span class="text-warning font-weight-400">due diligence STARS</span>
          aberto no momento para os fundos de investimentos nos quais você está
          cadastrado. Entraremos em contato caso hajam novas diligências!
        </p>
        <p class="text-right">
          Cordialmente,<br />
          <span class="font-weight-600"
            >Equipe <span class="text-warning">STARS</span></span
          >.
        </p>
      </div>
      <template slot="footer">
        <base-button type="white" @click="$router.push('/')">
          Voltar ao menu inicial
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "funds",
  data() {
    return {
      dueDiligences: [],
      empty: false,
      showModal: false,
    };
  },
  async mounted() {
    let loader = this.$loading.show({
      container: this.$refs.investor_evaluations,
      width: 150,
      height: 150,
      color: "#ffffff",
      backgroundColor: "transparent",
    });
    try {
      const { data: dueDiligences } = await api.get(
        "/investor-due-diligences?only_open=true"
      );
      if (dueDiligences.length) this.dueDiligences = dueDiligences;
      else this.empty = this.showModal = true;
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as informações");
    }
  },
  methods: {
    handleViewDueDiligence(dueDiligenceId) {
      this.$router.push(
        `/investidor/due-diligences/${dueDiligenceId}/startups`
      );
    },
  },
};
</script>
<style scoped>
.card {
  margin-top: 10px;
}
.card-profile-image img {
  width: 180px;
  height: 180px;
}
.text-default-case {
  text-transform: none !important;
}
</style>
